export const title = 'Downloads (Chart)';

Number of new app installations over time.
